import { ClipLoader } from "react-spinners";
import styles from "./Loader.module.css";
import type { ReactNode } from "react";

const Loader = ({ children }: { children?: ReactNode }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.spinnerWrapper}>
        <ClipLoader
          color="#b4358b"
          size={60}
          cssOverride={{ position: "absolute", top: 0, left: 0 }}
        />
        <ClipLoader
          color="#ee850e"
          size={60}
          cssOverride={{
            position: "absolute",
            top: 0,
            left: 0,
            animationDelay: "0.3s",
          }}
        />
        {children}
      </div>
    </div>
  );
};

export default Loader;
